import {
  TOGGLE_LANGUAGE
} from '../actions/languageActions'
import { toggleLang } from '../../util/Localizer'

const Language = (state = {}, action) => {
  switch (action.type) {
    case TOGGLE_LANGUAGE:
      toggleLang()
      return state
    default:
      return state
  }
}

export default Language



// WEBPACK FOOTER //
// ./src/redux/reducers/languageReducer.js